import { all } from 'redux-saga/effects';
import { watchRefreshToken } from './userSagas';

export default function* rootSaga() {
    yield all([
        watchRefreshToken(),
        // Здесь можно добавить другие саги
    ]);
}